import { usePaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";

import {
  AdminComplexAdminAssignment,
  ComplexAdminFilters,
} from "./complexAdmins.types";

export const ADMIN_COMPLEX_ADMINS_ENDPOINT = "v1/admin/complex-admins";
export const ADMIN_COMPLEX_ADMINS_QUERY_KEY = ["admin", "complex-admins"];

export const useComplexAdminsQuery = (
  params?: PaginatedQueryParams<ComplexAdminFilters>,
  options?: { enabled?: boolean },
) => {
  return usePaginatedQuery<
    AdminComplexAdminAssignment,
    ComplexAdminFilters
  >({
    endpoint: ADMIN_COMPLEX_ADMINS_ENDPOINT,
    queryKeyBase: ADMIN_COMPLEX_ADMINS_QUERY_KEY,
    params,
    enabled: options?.enabled,
  });
};
